"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnToggleContainer = void 0;
const react_1 = __importDefault(require("react"));
// TODO: The kyruus checkbox is currently not compatible with `getToggleHiddenProps`
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const button_1 = __importDefault(require("@kyruus/button"));
const menu_1 = __importStar(require("@kyruus/menu"));
const DEFAULT_SHOW_HIDE_LABEL = 'Show / Hide Columns';
const ColumnToggleContainer = ({ columns, buttonLabel = DEFAULT_SHOW_HIDE_LABEL, tableId }) => {
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const containerId = `${tableId !== null && tableId !== void 0 ? tableId : 'table'}-column-toggle-menu`;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const allButOneHidden = columns.filter((c) => c.getToggleHiddenProps().checked).length === 1;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(button_1.default, { "aria-controls": containerId, "aria-haspopup": "true", onClick: handleClick, variant: "outlined" }, buttonLabel),
        react_1.default.createElement(menu_1.default, { id: containerId, anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, columns.map((column) => {
            const _a = column.getToggleHiddenProps(), { checked, onChange } = _a, toggleHiddenProps = __rest(_a, ["checked", "onChange"]);
            return (react_1.default.createElement(menu_1.MenuItem, { key: `${column.id}-${checked}`, value: column.id, onClick: () => {
                    if (!checked || !allButOneHidden) {
                        column.toggleHidden(checked);
                    }
                } },
                react_1.default.createElement(Checkbox_1.default, Object.assign({ color: "primary", checked: checked, disabled: checked && allButOneHidden }, toggleHiddenProps)),
                react_1.default.createElement(ListItemText_1.default, { primary: column.Header })));
        }))));
};
exports.ColumnToggleContainer = ColumnToggleContainer;
//# sourceMappingURL=index.js.map